module.exports = __webpack_public_path__ + "img/new6.27263775.png";